export const PRICECHANGE_NOTIFICATION_TYPE = 'PRICECHANGE';
export const SUNSET_NOTIFICATION_TYPE = 'SUNSET';
export const TODAY_GROUPING_TYPE = 'today';
export const OTHERS_GROUPING_TYPE = 'others';
export const GROUPING_TYPE = 'groupingType';
export const ALL = 'ALL';
